import { render, staticRenderFns } from "./ChatNoMessages.vue?vue&type=template&id=17e77a12&scoped=true"
import script from "./ChatNoMessages.vue?vue&type=script&lang=ts"
export * from "./ChatNoMessages.vue?vue&type=script&lang=ts"
import style0 from "./ChatNoMessages.vue?vue&type=style&index=0&id=17e77a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e77a12",
  null
  
)

export default component.exports